// eslint-disable-next-line no-restricted-imports
import { AnalyticsContext as AkAnalyticsContext } from '@atlaskit/analytics-next';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE = 'marketplaceCtx';
const MarketplaceAnalyticsContext = props => {
  const {
    attributes = {},
    properties = {},
    children
  } = props;
  return /*#__PURE__*/_jsx(AkAnalyticsContext, {
    data: {
      [MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE]: {
        attributes,
        properties
      }
    },
    children: children
  });
};
export default MarketplaceAnalyticsContext;